const mapErrors = (model, errors) => {
    let errorsMapped = {};
    Object.keys(model).forEach((field) => {
        let fieldError = errors.find((er) => er.field === field);
        if (fieldError) errorsMapped[field] = fieldError.defaultMessage;
    })
    return errorsMapped;
}

const mapFieldErrors = (errors) => {
    let fieldErrors = {};
    errors.forEach((error) => {
        fieldErrors[error.field] = error.defaultMessage;
    });
    return fieldErrors;
}

export {
    mapErrors, 
    mapFieldErrors
}